// extracted by mini-css-extract-plugin
module.exports = {"container":"_61cc05a7c9--container--3Iv8A","title":"_61cc05a7c9--title--3PbRc","description":"_61cc05a7c9--description--NlaPQ"};